import { Component, OnInit } from '@angular/core';
import { SharedService } from "./../../shared/shared.service";
import { ActionStatusService } from "./../../shared/action-status.service";
import { ActionStatus } from "./../../shared/action-status";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private actionStatusService: ActionStatusService) { }

  notificatinList: any[];
  actionNames: string[];
  errorMessage: string = "";

  ngOnInit() {

    this.sharedService.showSpinner();
    this.actionStatusService.getAll().subscribe(
      data => {
        //console.log(this.getPivotArray2(data));
        this.notificatinList = data;// this.getPivotArray2(data);
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )
  }

  getPivotArray2(dataArray) {

    let output: any[] = [];

    var distinctSortNames = dataArray.map(x => x.SortName)
      .filter((value, index, self) => self.indexOf(value) === index);

    this.actionNames = distinctSortNames;

    var distinctMobileNos = dataArray.map(x => x.MobileNo)
      .filter((value, index, self) => self.indexOf(value) === index);


    for (var i = 0; i < distinctMobileNos.length; i++) {

      let pivotObject: any;

      for (var j = 0; j < distinctSortNames.length; j++) {
        let object = dataArray.filter(x => x.MobileNo == distinctMobileNos[i] && x.SortName == distinctSortNames[j])[0];

        if (pivotObject == undefined) {
          pivotObject = { DevoteeName: object.DevoteeName, MobileNo: object.MobileNo };
        }

        pivotObject[distinctSortNames[j]] = (object == undefined) ? "-" : object.Status;
      }

      output.push(pivotObject);
    }

    return output;
  }


  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {}, ret = [];
    var newCols = [];
    for (var i = 0; i < dataArray.length; i++) {

      console.log(dataArray[i][rowIndex]);

      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {};
      }
      result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i][dataIndex];

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) == -1) {
        newCols.push(dataArray[i][colIndex]);
      }
    }

    newCols.sort();
    var item = [];

    //Add Header Row
    item.push('Item');
    item.push.apply(item, newCols);
    ret.push(item);

    //Add content 
    for (var key in result) {
      item = [];
      item.push(key);
      for (var i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || "-");
      }
      ret.push(item);
    }
    return ret;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/notification/notification.component.ts